// Travel Insurance Policy Constants and Data
import addmore from "../../assets/images/Addmore-icon.svg";
import addpassengerTravel from "../../assets/images/addpassenger-travel.svg";
import cancelPolicy from "../../assets/images/cancelPolicy.svg";
import changefileicon from "../../assets/images/changefileicon.svg";
import changetripdateTravel from "../../assets/images/changetripdate-travel.svg";
import modifypassengerTravel from "../../assets/images/modifypassenger-travel.svg";
import refreshIcon from "../../assets/images/refresh-dark.svg";

// Travel-specific action type constants
export const CHANGE_PLAN_TRAVEL = "CHANGE_PLAN_TRAVEL";
export const ADD_MORE_COVERS_TRAVEL = "ADD_MORE_COVERS_TRAVEL";
export const ADD_PASSENGER_TRAVEL = "ADD_PASSENGER_TRAVEL";
export const MODIFY_PASSENGER_TRAVEL = "MODIFY_PASSENGER_TRAVEL";
export const CHANGE_TRIP_DATE_TRAVEL = "CHANGE_TRIP_DATE_TRAVEL";
export const CANCEL_POLICY_TRAVEL = "CANCEL_POLICY_TRAVEL";

// Travel Policy Overview Data
export const travelPolicyOverview = {
  policyInfo: {
    policy_label: "Your Travel Policy",
    policy_label_ar: "وثيقة السفر الخاصة بك",
    status: "Active",
    status_ar: "نشيط",
    planName: "Travel Insurance Policy",
    planName_ar: "وثيقة تأمين السفر",
    policyNumber: "",
    date: {
      startDate: "",
      endDate: "",
    },
    btn: {
      icon: refreshIcon,
      btn_lable_en: "Renew Policy",
      btn_lable_ar: "تجديد الوثيقة",
    },
  },
  cards: [
    {
      icon: "",
      value: "24/7 Travel Assistance",
      value_ar: "مساعدة السفر على مدار الساعة",
      call_option: {
        icon: "",
        lable_en: "Call +973 17223351",
        label_ar: "+973 اتصل على 17223351",
        phone: "+97317223351"
      }
    },
    {
      icon: "",
      value: "Emergency Medical Services",
      value_ar: "خدمات الطوارئ الطبية",
      call_option: {
        icon: "",
        lable_en: "Call +973 17223351",
        label_ar: "+973 اتصل على 17223351",
        phone: "+97317223351"
      }
    },
    {
      icon: "",
      value: "Lost Baggage Support",
      value_ar: "دعم الأمتعة المفقودة",
      call_option: {
        icon: "",
        lable_en: "Call +973 17223351",
        label_ar: "+973 اتصل على 17223351",
        phone: "+97317223351"
      }
    }
  ]
};

// Travel Policy Manage Actions
export const manageTravelPolicy = {
  cards: [
    {
      icon: changefileicon,
      value: "Change Plan",
      value_ar: "تغيير الخطة",
      type: CHANGE_PLAN_TRAVEL,
      hideForPlatinum: true // Hide when plan is Platinum
    },
    {
      icon: addmore,
      value: "Add More Covers",
      value_ar: "إضافة المزيد من الأغطية",
      type: ADD_MORE_COVERS_TRAVEL
    },
    {
      icon: addpassengerTravel,
      value: "Add Passenger",
      value_ar: "إضافة مسافر",
      type: ADD_PASSENGER_TRAVEL,
      showForIndividual: false, // Only show for family plans
      showForFamily: true
    },
    {
      icon: modifypassengerTravel,
      value: "Modify Passenger Details",
      value_ar: "تغيير معلومات المسافر",
      type: MODIFY_PASSENGER_TRAVEL,
      showForIndividual: false, // Hide for individual plans
      showForFamily: true
    },
    {
      icon: changetripdateTravel,
      value: "Change Trip Date",
      value_ar: "تغيير تاريخ السفر",
      type: CHANGE_TRIP_DATE_TRAVEL
    },
    {
      icon: cancelPolicy,
      value: "Cancel Policy",
      value_ar: "إلغاء السياسة",
      type: CANCEL_POLICY_TRAVEL
    }
  ]
};

// Function to check if inception date has been reached (today >= inception date)
const isInceptionDateReached = (inceptionDate) => {
  if (!inceptionDate) return false;

  try {
    let incDate;

    // Handle different date formats
    if (typeof inceptionDate === 'string' && inceptionDate.includes("/")) {
      // DD/MM/YYYY format
      const parts = inceptionDate.split("/");
      if (parts.length === 3) {
        incDate = new Date(parts[2], parts[1] - 1, parts[0]); // year, month-1, day
      }
    } else {
      // Unix timestamp or other format
      const timestamp = typeof inceptionDate === 'string' ? parseInt(inceptionDate) : inceptionDate;
      if (!isNaN(timestamp) && timestamp > 1000000000) {
        incDate = new Date(timestamp * 1000);
      } else {
        incDate = new Date(inceptionDate);
      }
    }

    if (!incDate || isNaN(incDate.getTime())) {
      return false;
    }

    // Compare with current date (only date part, not time)
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    incDate.setHours(0, 0, 0, 0);

    return today >= incDate;
  } catch (error) {
    console.error("Error checking inception date:", error);
    return false;
  }
};

// Function to filter cards based on plan type, plan name, and inception date
export const getFilteredTravelCards = (policyDetails) => {
  const planType = policyDetails?.PlanType?.toLowerCase();
  const planName = policyDetails?.PlanName?.toLowerCase()?.trim();
  const planCode = policyDetails?.PlanCode?.toUpperCase()?.trim();
  const isIndividualPlan = planType === 'individual' || planType === 'single';
  // Check if plan is Platinum (PL code or name contains platinum)
  const isPlatinumPlan = planCode === 'PL' || planName?.includes('platinum') || planName?.includes('platinium');

  // All endorsements are only available before the inception date
  const inceptionDate = policyDetails?.DepartureDate || policyDetails?.FromDateStr;
  const isPastInception = isInceptionDateReached(inceptionDate);

  // If today is on or after inception date, no endorsement options are available
  if (isPastInception) {
    return manageTravelPolicy.cards.filter(card => card.type === CANCEL_POLICY_TRAVEL);
  }

  return manageTravelPolicy.cards.filter(card => {
    // Hide Change Plan for Platinum plans
    if (card.hideForPlatinum && isPlatinumPlan) {
      return false;
    }

    // Apply plan type restrictions
    if (card.showForIndividual !== undefined || card.showForFamily !== undefined) {
      if (isIndividualPlan) {
        return card.showForIndividual !== false;
      } else {
        return card.showForFamily !== false;
      }
    }

    return true;
  });
};